import React from "react";
import Select from './Select.style';
import { Select as AntSelect } from "antd";

export default class extends React.Component {

    render() {
        return (
            <Select className="width100" { ...this.props }>
                { this.props.children }
            </Select>
        );
    }

}

export class Option extends AntSelect.Option {}